

	
export function processTabs(base = document) {
	base.querySelectorAll('.wp-block-smarttouch-tabs').forEach(tabs=>{
		if(tabs.initialized) return;
		tabs.initialized = true;
		const tabPanels = tabs.querySelector('.tab-panels');
		const firstPanel = tabs.querySelector('.wp-block-smarttouch-tab:first-child');
		const panels = tabs.querySelectorAll('.wp-block-smarttouch-tab');
		panels.forEach(panel => {
			panel.classList.add('is-hidden');
			new ResizeObserver(entries=>{
				for (let entry of entries) {
					if(entry.target.classList.contains('is-hidden')) continue;
					tabPanels.style.height = Math.round(entry.target.offsetHeight) + 'px';
				}
			}).observe(panel);
		});
		firstPanel.classList.remove('is-hidden');
		const labels = tabs.querySelectorAll('.tab-label');
		labels.forEach(tab => {
			if(!tab.querySelector('a')) tab.addEventListener('click',(e)=>{
				labels.forEach(tab=>{tab.classList.remove('is-active')});
				e.target.classList.add('is-active');
				const panels = tabs.querySelectorAll('.wp-block-smarttouch-tab');
				panels.forEach(panel => { panel.classList.add('is-hidden'); });
				panels[e.target.dataset.tab].classList.remove('is-hidden');
				tabPanels.style.height = panels[e.target.dataset.tab].getBoundingClientRect().height + 'px';
			});
		});
		setTimeout(function(){
			tabs.classList.remove('loading');
		},100);
		setTimeout(function(){
			tabPanels.style.transition = 'height 0.5s ease';
		},1000);
	});
}